// extracted by mini-css-extract-plugin
export var defaultWrapper = "_f6-3";
export var downloadButton = "_f6-4";
export var fileContainer = "_f6-9 _f6-7";
export var fileContainerBase = "_f6-7";
export var fileContainerBaseSm = "_f6-a _f6-7";
export var fileContainerFixedHeight = "_f6-8 _f6-7";
export var fileContainerFixedHeightSm = "_f6-c _f6-a _f6-7";
export var fileContainerSm = "_f6-b _f6-a _f6-7";
export var fileInfo = "_f6-5";
export var fileInfoWidthRestricted = "_f6-6";
export var fileType = "_f6-1";
export var fileTypeName = "_f6-2";
export var fileTypeSm = "_f6-d _f6-1";
export var image = "_f6-0";
export var link = "_f6-f";
export var overflowEllipsis = "_f6-e";